import styled from 'styled-components'

export const ContentUnavailableWrapper = styled.div`
  height: calc(100% - 360px);
  margin-right: 112px;
`
